import { Prim } from "@base/util/TypeUtil";
import { IArticleFeatureContext } from "@biz/definitions/ArticleFeatureDefinitions";

const renderColorComboItem: (val: Prim, context: IArticleFeatureContext) => React.ReactNode = () => <>renderColorComboItemEmpty not supported!</>
export const FeatureFormatters = {
  renderColorComboItem
};